import http from "../../Services/Auth/config/http-common";
import ICatUbicaciones from "../../Interfaces/Catalogos/ICatUbicaciones";
import IRespuesta from "../../Interfaces/Respuestas/IRespuesta";

class CatUbicacionesDataService {
  Get() {
    return http.get<ICatUbicaciones[]>("Catalogos/CatUbicaciones/Get");
  }
  Append(data: ICatUbicaciones) {
    return http.post<ICatUbicaciones>(`Catalogos/CatUbicaciones/Append`,data);
  }
  Delete(id: number) {
    return http.delete<IRespuesta>(`Catalogos/CatUbicaciones/Delete/${id}`);
  }
}
export default new CatUbicacionesDataService();